import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {RootState} from '../../store';
import {PermissionModule} from '../../types/enums/permission/PermissionModule';
import {PermissionType} from '../../types/enums/permission/PermissionType';
import {useHasPermission} from '../../util/PermissionUtil';
import DesktopHeader from './DesktopHeader';
import './Header.scss';
import MobileHeader from './MobileHeader';

const Header = () => {
    const loggedIn = useSelector((state: RootState) => state.login.loggedIn);
    const location = useLocation();
    const canSeeReportsForQMResponsibles = useHasPermission(PermissionModule.REPORT, PermissionType.WRITE);
    const canWriteSystemSettings = useHasPermission(PermissionModule.SYSTEM_SETTINGS, PermissionType.WRITE);

    const isSticky = useMemo(() => {
        if (location.pathname.startsWith('/reports')) {
            return canSeeReportsForQMResponsibles;
        } else if (location.pathname.startsWith('/settings')) {
            return canWriteSystemSettings;
        }

        const nonStickyPages = ['/live', '/summary', '/archive-reports', '/extension-deadline'];

        return !nonStickyPages.some(page => location.pathname.startsWith(page));
    }, [location, canSeeReportsForQMResponsibles, canWriteSystemSettings]);
    if (!loggedIn) {
        return null;
    }

    return (
        <header className={isSticky ? 'header-fixed' : undefined}>
            <DesktopHeader/>
            <MobileHeader/>
        </header>
    );
};

export default Header;
